import React from "react";
import ReportConsolidatedTable from "../../ReportTable/Consoloidated/ReportConsolidatedTable";

const ReportConsolidatedTableResult = (props) => {
  return <ReportConsolidatedTable data={props.unitsReportData} />;
};

export default React.memo(ReportConsolidatedTableResult);
